/**
 * Public invitation link helpers.
 *
 * Two shapes exist for the same token:
 *  - the SPA page (`/rsvp/:token`) the guest actually interacts with, and
 *  - the share/preview link (`/i/:token`), a server-rendered page whose only
 *    job is to carry Open Graph tags so WhatsApp/iMessage/Facebook show the
 *    event name, date and logo, then bounce the visitor to the SPA page.
 *
 * Chat apps never run JavaScript when they unfurl a link, so a link that must
 * preview has to be the `/i/` one — hence a single shared definition used by
 * the backend (canonical URL, email links) and the frontend (copy/share UI).
 */
/** CloudFront routes this prefix to the API, which renders the preview page. */
export const INVITE_PREVIEW_PREFIX = '/i';
/** Path of the SPA invitation/RSVP page for a token. */
export function inviteRsvpPath(token) {
    return `/rsvp/${encodeURIComponent(token)}`;
}
/** Path of the shareable link-preview page for a token. */
export function invitePreviewPath(token) {
    return `${INVITE_PREVIEW_PREFIX}/${encodeURIComponent(token)}`;
}
/** Absolute shareable link — `origin` is an app origin without a trailing slash. */
export function invitePreviewUrl(origin, token) {
    return `${origin.replace(/\/+$/, '')}${invitePreviewPath(token)}`;
}
/** Absolute SPA invitation URL for a token. */
export function inviteRsvpUrl(origin, token) {
    return `${origin.replace(/\/+$/, '')}${inviteRsvpPath(token)}`;
}
//# sourceMappingURL=inviteLinks.js.map